/**
 * Indicates whether a pricing preset is forced, optional, or conditional
 * for a vehicle category. Synced to proto; frontend decides how to handle each.
 */
export enum PricingPresetRequirementEnum {
	FORCED = 'forced',
	OPTIONAL = 'optional',
	CONDITIONAL = 'conditional',
}
